import { createIcon } from '@chakra-ui/react';

export const MbePickUp = createIcon({
  displayName: 'MbePickUp',
  viewBox: '0 0 105 90',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg">
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="4"
      >
        <path d="m33.948 40.488 6.255 5.615s3.239 2.198 5.074 1.7c3.32-.902 6.324-1.323 9.57-.183 5.736 2.015 13.164 5.73 14.288 6.02 1.91.494 4.071 2.809 2.87 4.417-1.203 1.605-4.086 3.102-6.67 3.334-2.196.196-6.85-3.895-10.757-3.01-1.477.335-1.06 4.088.209 5.363 1.269 1.274 17.01 18.454 17.01 18.454C73.927 84.34 72.42 88 69.402 88H39.64a3.376 3.376 0 0 1-2.393-.995l-8.853-10.112c-2.857-2.867-6.631-6.968-6.631-11.026v-4.41l-4.437-4.318M4.196 59.333V83.59h28.543" />
        <path d="M74.457 83.59H103V6.41H17.37M2 46.103s13.174 13.047 13.174 13.23l21.956-22.05L2 2" />
        <path d="M43.717 6.41v11.026h21.957V6.41M48.109 88l-4.392-4.41M56.891 88 52.5 83.59M65.674 88l-4.391-4.41" />
      </g>
    </svg>
  ),
});
